<script lang="ts">
    import {Rose} from "../rose.ts";
    import {Link} from "svelte-routing";

    export let rose: Rose;
    export let block: boolean = true;

    let svg;
    // fetch(rose.gargot).then(data => data.text()).then(txt => svg = txt.replace('width="512"', '').replace('height="512"', '').replaceAll("sketch", "")).catch(err => console.error(err));
    // console.log(rose.resultat)
</script>

<Link to="detalls/{rose.id}">
    <div class="gallery-element">
        <img src="{rose.resultat}" alt="Rosa" class:block-image={block}>
        <img id="gargot" src="{rose.gargot}" alt="Gargot de la rosa" class:block-image={block}>
        <div class="gallery-element-info">
            <p>Descripció: "{rose.description}"</p>
        </div>
    </div>
</Link>

<style>
    .gallery-element {
        max-width: 400px;
        max-height: 400px;
        aspect-ratio: 1;
        overflow: hidden;
        position: relative;
        cursor: pointer;
    }

    img {
        width: 100%;
        opacity: 1;
        display: block;
        /* transition: height 0ms 0ms, opacity 200ms 0ms; */
        object-fit: cover;
        object-position: 0 0;
    }

    #gargot {
        object-position: bottom;
    }

    .block-image {
        display: block;
    }

    .gallery-element-info {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 0.5em 2em;
        background-color: #00000088;
        color: white;
        opacity: 0;
    }

    .gallery-element-info > p {
        font-size: 1.25em;
        margin: 0.5em 0;
    }

    @keyframes show-image-info {
        from {
            transform: scaleY(0);
            opacity: 0;
        }
        to {
            transform: scaleY(1);
            opacity: 1;
        }
    }

    @keyframes img-dp {
        from {
            height: 100%;
        }
        to {
            height: 0;
        }
    }

    @keyframes svg-ap {
        from {
            height: 0;
        }
        to {
            height: 100%;
        }
    }

    .gallery-element:hover .gallery-element-info {
        transform-origin: center bottom;
        animation: show-image-info .2s ease-in-out;
        opacity: 1;
    }

    .gallery-element:hover img {
        animation: img-dp .3s linear forwards;
        /* opacity: 0;
        display: none; */
        /* transition: height 0ms 200ms, opacity 200ms 0ms; */
    }
    .gallery-element #gargot {
        bottom: 0;
        width: 100%;
        height: 0;
        /* transition: height 0ms 200ms, opacity 200ms 0ms; */
    }
    .gallery-element:hover #gargot {
        animation: svg-ap .3s linear forwards;
        /* opacity: 1;
        height: 100%; */
        /* transition: height 0ms 0ms, opacity 200ms 0ms; */
    }

    /* :global(svg.drawing) {
        cursor: pointer;
        width: inherit;
        height: 100%;
        background-color: white;
    } */

</style>